import script from "./BooksBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BooksBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./BooksBlockSkeleton.vue?vue&type=style&index=0&id=22f1a15b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f1a15b"]])

export default __exports__